import './Header.scss'
import './NavItems.scss'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import logoM from '../../../assets/images/logo.svg';
import authService from '../../../Axios/services/auth.service';
import { socket } from '../../../Axios/services/msgs.service';
import { useDispatch, useSelector } from "react-redux";
import { setMe, setToken } from '../../../store/actions/authActions';
import { UserProfileImageTrigger } from '../../content/Profile/UserProfile/UserProfile';
import { Terms } from './Terms';
import { toggleCommunityPopup } from '../../../store/actions/mainActions';
import { SidebarMenu } from '../SidebarMenu/SidebarMenu';
import { Fragment } from 'react';
import { SidebarEventMenu } from '../SidebarEventMenu/SidebarEventMenu';
import { useTranslation } from "react-i18next";
import { Nav, Navbar, Modal, Button } from "react-bootstrap";
import { ReactComponent as CurriculaIcon } from './../../../assets/images/curricula.svg';
import { ReactComponent as HRIcon } from './../../../assets/images/hr.svg';
import { ReactComponent as LogOutIcon } from './../../../assets/images/logout.svg';
import { ReactComponent as ConnectLogo } from './../../../assets/images/connectLogo.svg';
import useScrollTop from '../../../hooks/useScrollTop';
import { isMobileApp } from '../../../helpers/helpers';

export interface NavItemsProps {
  className: string
  iconsHeight: number
}

export const NavItems = (props: NavItemsProps) => {

  const [t] = useTranslation('common');
  const { me } = useSelector((state: any) => state.auth);
  const location = useLocation();
  const navigate = useNavigate()
  const { className, iconsHeight } = props;
  const pathname = location?.pathname;
  const { scrollToTop } = useScrollTop();

  const handelNavigate = (path: string) => {
    scrollToTop();
    navigate(path);
  }

  const isFeedPath = pathname === '/';
  const isCampusPath = pathname.indexOf('/my-campus') !== -1;
  const isCurriculaPath = pathname.indexOf('/curricula') !== -1;
  const isSHIHRPath = pathname.indexOf('/shihr') !== -1;


  return (<div className={`nav-items-wrapper ${className}`}>
    <div className="nav-item" onClick={() => handelNavigate('/my-feed')}>
      <svg className="mx-1" xmlns="http://www.w3.org/2000/svg"
        width={iconsHeight}
        height={iconsHeight}
        viewBox="0 0 19.5 19.5">
        <defs>
          <style>{`.isFeedPath{fill:none;stroke:${isFeedPath ? "#0089ce" : "#001f4c"};stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}`}</style>
        </defs>
        <g transform="translate(-1727.75 -335.75)">
          <path className="isFeedPath" d="M1741.978,357.326H1736.5v-5.087a2.739,2.739,0,0,1,2.739-2.739h0a2.739,2.739,0,0,1,2.739,2.739Z" transform="translate(-1.739 -2.826)" />
          <path className="isFeedPath" d="M1746.164,342.528l-2.795-1.945V336.5H1741.8v2.994l-4.3-2.994-8.664,6.028a.782.782,0,0,0-.336.643v1.156h2.348v9.391a.783.783,0,0,0,.783.783h11.739a.783.783,0,0,0,.783-.783v-9.391h2.348V343.17A.782.782,0,0,0,1746.164,342.528Z" />
        </g>
      </svg>
      <div className={isFeedPath ? 'tab-active' : ''}>{t('My Feed')}</div>
      {isFeedPath && <div className="hr"></div>}
    </div>

    {me && me.events && me.events.length > 0 &&
      <div className="nav-item" onClick={() => handelNavigate('/my-campus')}>
        <svg className="mx-1" xmlns="http://www.w3.org/2000/svg"
          width={iconsHeight}
          height={iconsHeight}
          viewBox="0 0 21.214 19.804"
        >
          <defs>
            <style>{`.isCampusPath{fill:none;stroke:${isCampusPath ? "#0089ce" : "#001f4c"};stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}`}</style>
          </defs>
          <g transform="translate(-551.75 -336.75)">
            <line className="isCampusPath" x2="19.714" transform="translate(552.5 337.5)" />
            <path className="isCampusPath" d="M0,0H18a0,0,0,0,1,0,0V12.714a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z" transform="translate(553.357 337.5)" />
            <line className="isCampusPath" x1="3.429" y2="4.286" transform="translate(557.643 351.214)" />
            <line className="isCampusPath" x1="3.429" y1="4.286" transform="translate(563.643 351.214)" />
          </g>
        </svg>
        <div className={isCampusPath ? 'tab-active' : ''}>
          {t('Campus')}
        </div>
        {isCampusPath && <div className="hr"></div>}
      </div>
    }

    {me && me.curricula && me.curricula.length > 0 &&
      <div className="nav-item curHover" onClick={() => handelNavigate('/curricula')}>
        <CurriculaIcon className={isCurriculaPath ? 'iconHeaderActive' : 'iconHeaderInActive'} />
        <div className={isCurriculaPath ? 'tab-active' : ''}>{t('Curricula')}</div>
        {isCurriculaPath && <div className="hr"></div>}
      </div>
    }

    {me && me.email.includes("shi.org.il") &&
      <div className="nav-item curHover" onClick={() => handelNavigate('/shihr')}>
        <HRIcon className={isSHIHRPath ? 'iconHeaderActive' : 'iconHeaderInActive'} />
        <div className={isSHIHRPath ? 'tab-active' : ''}>{t('HR')}</div>
        {isSHIHRPath && <div className="hr"></div>}
      </div>
    }

  </div>)
}


export const LogoutModal = (props: any) => {

  const dispatch = useDispatch();
  const { me } = useSelector((state: any) => state.auth);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleLogout = () => {
    authService.logout(me.email, me._id);
    dispatch(setToken(''))
    dispatch(setMe(null))
    window.location.href = '/';
  }

  return (
    <>

      {/*<svg onClick={handleShow} xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-logout" width="26" height="26" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#ffffff" fill="none" strokeLinecap="round" strokeLinejoin="round">*/}
      {/*    <path stroke="none" d="M0 0h24v24H0z" fill="none" />*/}
      {/*    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />*/}
      {/*    <path d="M7 12h14l-3 -3m0 6l3 -3" />*/}
      {/*</svg> */}
      <div onClick={handleShow} className="d-flex LogoutContainer mr-3">
        <LogOutIcon className="icon icon-tabler icon-tabler-logout" />
        <div className="LogoutText">Logout</div>
      </div>



      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Logout Hartman Connect</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you wish to logout? </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Stay
          </Button>
          <Button variant="primary" onClick={handleLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );


}


const Header = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState(false);
  const { me } = useSelector((state: any) => state.auth);
  const { currentPage, sidebarRouteData, currentCourse } = useSelector((state: any) => state.main);
  const [connected, setConnected] = useState(false);
  const [expanded, setExpanded] = useState<any>(false);

  const isFeedPath = '/my-feed';
  const isCampusPath = '/my-campus';
  const isCurriculaPath = '/curricula';
  const isSHIHRPath = '/shihr';

  const navbarRef = useRef(null);

  const navigateTo = (path: string) => {
    history(path);
    setExpanded(false);
  }

  useEffect(() => {

    if (me) {
      socket.emit('server', { message: 'Hello from ', user: me._id, client: socket.id });
    }
    const eventHandler = () => setConnected(true);

    socket.on("splash", (data) => {
      setNotificationMsg(data);
      setShowNotification(true);
    });

    function onDisconnect() {
      setConnected(false);
    }

    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('splash', eventHandler);
      socket.off('disconnect', onDisconnect);
    };

  })

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target as Node)) {
        setExpanded(false);
      }
    }

    if (expanded) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  const routeChangeToDonate = (path) => {
    const donatePath = `https://hartman.tfaforms.net/f/support-shalom-hartman`;
    const termsPath = 'https://www.hartman.org.il/terms-of-service/';
    const hartmanPath = 'https://www.hartman.org.il/';
    const isMobile = isMobileApp();
    const target = isMobile ? '_self' : '_blank';
    
    if (path === 'hartman') {
      window.open(hartmanPath, target);
    } else if (path === 'terms') {
      window.open(termsPath, target);
    } else if (path === 'donate') {
      window.open(donatePath, target);
    }
  }

  const openSupportRequest = () => {
    history('/help');
  }

  const showCommunityPopup = () => {
    dispatch(toggleCommunityPopup(true))
  }


  return (
    <Fragment>
      <header className="floatingHeader px-2 px-md-0 py-1 py-md-0 animate__animated animate__slideInDown">
        {showNotification && (
          <div className="notification">
            <div className="notificationMsgContainer">
              {notificationMsg ? (
                <div>
                  <div className="notificationMsgTitle">Important message: </div>
                  <div className="notificationMsg">{notificationMsg}</div>
                  <div className="closeNotification" onClick={() => setShowNotification(false)}>
                    Got it
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        )}
        <div className="flex-end py-md-0 py-3">
          <div className="main">
            <div className="container">
              <div className="row justify-content-end">
                <div className="col-12 col-lg-9 d-flex align-items-center justify-content-between px-0 px-md-3">
                  <ConnectLogo className="logo d-md-block d-none" />
                  <Navbar collapseOnSelect expanded={expanded} expand="lg" variant="dark" className="mobileHamburger" ref={navbarRef}>
                    <Navbar.Brand>
                      <div className="d-flex d-md-none align-items-center">
                        <UserProfileImageTrigger me={me} className="mobile-avatar" />
                        <img src={logoM} alt="logo" className="logo mx-4" />
                        <Navbar.Toggle onClick={() => setExpanded(expanded ? false : "expanded")} aria-controls="responsive-navbar-nav" />
                      </div>
                    </Navbar.Brand>

                    <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto">
                        <Nav.Item onClick={() => navigateTo(isFeedPath)}>Feed</Nav.Item>
                        <Nav.Item onClick={() => navigateTo(isCampusPath)}>My Seminars</Nav.Item>
                        <Nav.Item onClick={() => navigateTo(isCurriculaPath)}>Curricula</Nav.Item>
                        {me && me.email.includes("shi.org.il") && <Nav.Item onClick={() => navigateTo(isSHIHRPath)}>HR</Nav.Item>}
                        <Nav.Item onClick={openSupportRequest}>Help</Nav.Item>
                        <Nav.Item>
                          <Terms />
                        </Nav.Item>
                        <Nav.Item>
                          <LogoutModal />
                        </Nav.Item>
                        {me && me.role === "Administrator" ? <div className="AgentLabel">Agent: {navigator.userAgent.split("(")[0]}</div> : null}
                      </Nav>
                    </Navbar.Collapse>
                  </Navbar>

                  <div className="options headerDesktop">
                    <div className="headerIconsContainer d-none d-md-flex">
                      <div className={"pl-3 hartmanBtn"} onClick={() => routeChangeToDonate("hartman")}>
                        Hartman Website
                      </div>
                      <div className={"ml-3 mr-3 seperatorItem"}>|</div>
                      <Terms />
                      <div className={"ml-3 seperatorItem"}>|</div>
                      <div className={"pl-3 helpBtn"} onClick={openSupportRequest}>
                        Help
                      </div>
                      <div className={"ml-3 seperatorItem"}>|</div>
                      <LogoutModal />

                      <div className={"pl-3 donateBtn"} onClick={() => routeChangeToDonate("donate")}>
                        Donate
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white">
          <div className="flex-end">
            <div className="container">
              <div className="row justify-content-end">
                <div className="col-lg-9 col-12">
                  <NavItems iconsHeight={21} className={"d-none d-md-flex"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {currentPage === "coursePage" || currentPage === "coursePageLibrary" ? (
        <SidebarMenu iconSize={16} className="d-md-none d-block" sidebarRouteData={sidebarRouteData} currentCourse={currentCourse} />
      ) : null}
      {currentPage === "EventPage" || currentPage === "EventPageLibrary" || currentPage === "EventParticipantsPage" ? (
        <SidebarEventMenu iconSize={16} className="mobile_tab_bar d-md-none d-block" sidebarRouteData={sidebarRouteData} currentCourse={currentCourse} />
      ) : null}
    </Fragment>
  );
}

export default Header;